import { PERMISSIONS } from '../config/permissions';
import { ALL_ROLES } from '../config/roles';
import { Statuses } from '../types/status';

type RoleClaims = Record<string, string | number | undefined> | undefined;

export function isAsseticomStaff(roles: RoleClaims) {
  const asseticomRole = roles?.asseticom;

  if (asseticomRole === undefined || asseticomRole === null) {
    return false;
  }

  return Number(asseticomRole) > 0;
}

export function canManageMultipleSurveyorAssignments({
  roles,
  clientId,
}: {
  roles: RoleClaims;
  clientId?: string;
}) {
  return (
    isAsseticomStaff(roles) ||
    (!!clientId &&
      !!roles?.[clientId] &&
      PERMISSIONS.MULTI_SURVEYOR_MANAGE_CLIENT_IDS.includes(clientId))
  );
}

export function canAccessSurveySetupEditAction({
  roles,
  clientId,
}: {
  roles: RoleClaims;
  clientId?: string;
}) {
  return (
    Number(roles?.asseticom || 0) >= Number(ALL_ROLES.LEAD_SURVEYOR) ||
    (!!clientId &&
      Number(roles?.[clientId] || 0) >= Number(ALL_ROLES.LEAD_SURVEYOR))
  );
}

export function canShowSurveySetupEditAction({
  roles,
  clientId,
  status,
}: {
  roles: RoleClaims;
  clientId?: string;
  status?: string;
}) {
  const editableSetupStatuses = [
    Statuses.UNASSIGNED,
    Statuses.ISSUED,
    Statuses.NOT_STARTED,
  ];

  return (
    canAccessSurveySetupEditAction({ roles, clientId }) &&
    !!status &&
    editableSetupStatuses.includes(status as Statuses)
  );
}

export function canViewMultipleSurveyors({
  roles,
  clientId,
}: {
  roles: RoleClaims;
  clientId?: string;
}) {
  return (
    canManageMultipleSurveyorAssignments({ roles, clientId }) ||
    (!!clientId &&
      !!roles?.[clientId] &&
      PERMISSIONS.MULTI_SURVEYOR_VIEW_CLIENT_IDS.includes(clientId))
  );
}
